import * as React from 'react';
import { ArrowRight } from '@sravni/react-icons';
import { useStyles } from '@sravni/react-utils';
import { Icon } from '../../Icon/src/Icon.js';
import { Space } from '../../Space/src/Space.js';
import modules_3fa78883 from '../styles/Breadcrumb.module.less.js';

/**
 * @description A breadcrumb displays the current location within a hierarchy. It allows going back to states higher up in the hierarchy
 *
 * @component
 * @example
 * ```jsx
 * <Breadcrumb>
 *   <Breadcrumb.Item>Home</Breadcrumb.Item>
 * </Breadcrumb>
 * ```
 */
const Breadcrumb = React.forwardRef((props, ref) => {
    const { className, children, ...restProps } = props;
    const cx = useStyles(modules_3fa78883);
    const classNames = cx(className, 'container');
    const count = React.useMemo(() => React.Children.count(children), [children]);
    const navigation = React.useMemo(() => React.Children.map(children, (child, index) => (React.createElement(React.Fragment, null,
        child,
        index + 1 < count && React.createElement(Icon, { size: 16, icon: React.createElement(ArrowRight, null) })))), [children, count]);
    return (React.createElement(Space, { ref: ref, "data-qa": "Breadcrumb", align: "center", size: 8, className: classNames, ...restProps }, navigation));
});
Breadcrumb.defaultProps = {};
Breadcrumb.displayName = 'Breadcrumb';

export { Breadcrumb };
//# sourceMappingURL=Breadcrumb.js.map
